<div class="close-btn" (click)="onConfirmClick()">
    <img src="../../../../assets/images/smallclose.svg" />
</div>
<div class="modal-div-container bil-font-regular">
    <div class="step-heading">
        <b>What is Credit Report ?</b>
    </div>
    <div class="step">
        Your Experian Credit Information Report (‘Experian CIR’) contains detailed information of your credit/loan
        history, including identity information, credit accounts, loans, credit cards, payments, and recent enquiries.
    </div>
    <div class="step-dark">
        The details of this report help prospective lenders confirm your identity as well as assess your reliability as a borrower.
    </div>
    <div class="step-heading">
    <b>Which phone number should i use to get the OTP?</b>
    </div>
    <div class="step-5">
        Please use the mobile number registered with your operational bank to recieve an OTP
    </div>
</div>